/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-10-24",
    versionChannel: "nightly",
    buildDate: "2023-10-24T00:25:33.390Z",
    commitHash: "d5da655f8f1374bd0b2acd99cc94d52a2e21a246",
};
